/**
 * Zahlenfelder: Beim Hineinklicken ist der Inhalt markiert — auf die „1“ klicken,
 * „3“ tippen, fertig, ohne erst zu löschen. Gilt überall für Felder mit
 * inputMode decimal/numeric und type="number".
 */

const istZahlenfeld = (el) => el instanceof HTMLInputElement && !el.readOnly
    && (el.type === 'number' || el.inputMode === 'decimal' || el.inputMode === 'numeric');

export function zahlenfelderMarkieren() {
    let gedrueckt = null;
    let frisch = null;
    const runter = (e) => { gedrueckt = e.target; };
    const fokus = (e) => {
        if (!istZahlenfeld(e.target)) return;
        e.target.select();
        frisch = gedrueckt === e.target ? e.target : null;
    };
    // Beim Loslassen setzt der Browser sonst den Cursor und hebt die Markierung wieder auf
    const hoch = (e) => {
        if (frisch && e.target === frisch) e.preventDefault();
        frisch = null;
        gedrueckt = null;
    };
    document.addEventListener('mousedown', runter, true);
    document.addEventListener('focusin', fokus);
    document.addEventListener('mouseup', hoch, true);
    return () => {
        document.removeEventListener('mousedown', runter, true);
        document.removeEventListener('focusin', fokus);
        document.removeEventListener('mouseup', hoch, true);
    };
}
